import React from "react";
import { Link } from "@reach/router";

import "./style.scss";

const HomeCards = () => (
  <div className="home-cards">
    <div className="home-card">
      <div className="home-card-head">
        <span className="home-card-icon">
          <i className="far fa-map-marked-alt" />
        </span>
        <h3 className="home-card-title">Explore the Island</h3>
      </div>
      <p className="home-card-desc">
        Take our quick quiz to find your ideal Fire Island community, then dig
        into each town's vibe and beaches.
      </p>
      <Link to="/explore" className="home-card-link">
        Start exploring →
      </Link>
    </div>

    <div className="home-card">
      <div className="home-card-head">
        <span className="home-card-icon">
          <i className="far fa-mobile-alt" />
        </span>
        <h3 className="home-card-title">Get the Mobile App</h3>
      </div>
      <p className="home-card-desc">
        Buy and activate ferry and water taxi tickets right from your phone with
        FI mTickets.
      </p>
      <div className="home-card-stores">
        <a
          href="https://itunes.apple.com/us/app/fire-island-mtickets/id1240275646?mt=8"
          target="_blank"
          rel="noopener noreferrer"
          className="home-card-link"
        >
          App Store
        </a>
        <a
          href="https://play.google.com/store/apps/details?id=com.justride.fif"
          target="_blank"
          rel="noopener noreferrer"
          className="home-card-link"
        >
          Google Play
        </a>
      </div>
    </div>

    <div className="home-card">
      <div className="home-card-head">
        <span className="home-card-icon">
          <i className="far fa-comments" />
        </span>
        <h3 className="home-card-title">FAQ</h3>
      </div>
      <p className="home-card-desc">
        Crowd-sourced, regularly updated answers to the questions riders ask
        most.
      </p>
      <Link to="/info/faq" className="home-card-link">
        Browse the FAQ →
      </Link>
    </div>
  </div>
);

export default HomeCards;
